import { PreboardingHome } from "@/pages/preboarding/PreboardingHome.tsx";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { PortalAccessMode } from "@/types/employees/employee.types.ts";
import { Navigate } from "react-router-dom";

export function PreboardingRoute() {
  const { data: employeeMe } = useEmployeeMe();

  if (employeeMe && employeeMe.portal_access_mode === PortalAccessMode.full) {
    return <Navigate to="/home" replace />;
  }

  return <PreboardingHome />;
}
